import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const dismissRmaCreationFailure = {
  name: "dismissRmaCreationFailure" as const,
  input: z.object({ returnId: zExt.objectId(), integrationName: z.string() }),
  output: z.null(),
};
